import { useEffect, useState } from "react"
import { Link } from "react-router-dom"

import { toast } from "react-toastify"
import PlayerStats from "../../../interfaces/PlayerStats.interface"
import { getHistoricalBestPlayers } from "../../../services/players.services"
import Content from "../../../components/Content"
import Loader from "../../../components/Loader"
const HistoricalPage = () => {
    const [players, setPlayers] = useState<PlayerStats[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    useEffect(() => {
        getHistoricalBestPlayers()
            .then((res) => setPlayers(res.data.payload.bestPlayers))
            .catch(() => toast.error("Ha ocurrido un error"))
            .finally(() => setLoading(false))
    }, [])

    return (
        <Content>
            <div className="relative overflow-x-auto">
                <table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-50">
                        <tr>
                            <th scope="col" className="w-[50px] p-3">
                                #
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Jugador
                            </th>
                            <th scope="col" className="px-6 py-3">
                                País
                            </th>
                            <th scope="col" className="px-6 py-3">
                                Calidad
                            </th>
                        </tr>
                    </thead>
                    {!loading ?
                        <tbody>
                            {players.map((stats, index) => (
                                <tr key={stats.player?.id as string} className="bg-white border-b">
                                    <td className="px-6 py-4">
                                        {index + 1}
                                    </td>
                                    <th scope="row" className="flex items-center gap-5 px-6 py-4 font-medium text-gray-900 whitespace-nowrap">
                                        <div className="flex items-center justify-center bg-gray-100 w-[40px] h-[40px] rounded-full text-zinc-700 font-bold">{stats?.player?.name?.at(0)?.toLocaleUpperCase()}</div>
                                        <Link to={`/p/${stats?.player?.name}`}>{stats.player?.name}</Link>
                                    </th>
                                    <td className="px-6 py-4">
                                        {stats?.player?.country ?
                                            <div className="flex items-center gap-2">
                                                <img className="bg-white" src={`https://flagsapi.com/${stats?.player?.country?.split(",")[0]}/flat/32.png`} alt="flag-country"></img>
                                                <p className="text-zinc-700">{stats?.player?.country?.split(",")[1]}</p>
                                            </div>
                                            : '-'}
                                    </td>
                                    <td className="px-6 py-4">
                                        {stats?.base_stats?.quality?.toFixed(2)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                        :
                        <Loader />
                    }
                </table>
            </div>
        </Content>
    )
}

export default HistoricalPage